import { createContext, useContext, useState, ReactNode } from 'react';

interface ChatHistorySidebarContextType {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    toggleSidebar: () => void;
    openSidebar: () => void;
    closeSidebar: () => void;
}

const defaultContextValue: ChatHistorySidebarContextType = {
    isOpen: false,
    setIsOpen: () => { },
    toggleSidebar: () => { },
    openSidebar: () => { },
    closeSidebar: () => { },
};

const ChatHistorySidebarContext = createContext<ChatHistorySidebarContextType>(defaultContextValue);

export function useChatHistorySidebar() {
    return useContext(ChatHistorySidebarContext);
}

interface ChatHistorySidebarProviderProps {
    children: ReactNode;
}

export function ChatHistorySidebarProvider({ children }: ChatHistorySidebarProviderProps) {
    const [isOpen, setIsOpen] = useState(false);

    const toggleSidebar = () => setIsOpen(prev => !prev);
    const openSidebar = () => setIsOpen(true);
    const closeSidebar = () => setIsOpen(false);

    return (
        <ChatHistorySidebarContext.Provider value={{ isOpen, setIsOpen, toggleSidebar, openSidebar, closeSidebar }}>
            {children}
        </ChatHistorySidebarContext.Provider>
    );
}